<div class="col font-italic text-secondary pointer">
  <div *ngFor="let textLine of getTextLinesStart(); let last=last">{{textLine}}&nbsp;&nbsp;<app-show-more-less-button
      *ngIf="!animationBusy && !more && last && needsMore()" [(more)]="more"></app-show-more-less-button></div>
  <div class="collapsable-text-lines" [@slideInHorizontal]="!more" (@slideInHorizontal.start)="animationBusy=true"
    (@slideInHorizontal.done)="animationBusy=false">
    <div *ngFor="let textLine of getTextLinesEnd(); let last=last">{{textLine}}&nbsp;&nbsp;<app-show-more-less-button
        *ngIf="more && last && needsMore()" [(more)]="more"></app-show-more-less-button></div>
  </div>
</div>
